/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shopping_Filter_LabelInputs */

const en_shopping_filter_label = /** @type {(inputs: Shopping_Filter_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter by recipe`)
};

const de_shopping_filter_label = /** @type {(inputs: Shopping_Filter_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nach Rezept filtern`)
};

/**
* | output |
* | --- |
* | "Filter by recipe" |
*
* @param {Shopping_Filter_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const shopping_filter_label = /** @type {((inputs?: Shopping_Filter_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shopping_Filter_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_shopping_filter_label(inputs)
	return en_shopping_filter_label(inputs)
});